import axios from "axios";

// Sales targets - one amount per branch per month, optionally per salesman
// (the user who raised the sale). `period` is any date in the month; the
// server stores the 1st.
const base_path = window.APP_CONFIG?.BASE_URL;
const R = `${base_path}/Api/SalesTarget`;

// { branchIDs, fromPeriod, toPeriod, userID?, level?: "branch" | "user" }
// -> [{ guid, branchID, branchName, userID, userName, period, amount, level, achieved, achievedPct, targetToDate }]
export const getSalesTargets = async (data) => {
  const response = await axios.post(`${R}/GetAll`, data);
  return response.data;
};

// { targets: [{ branchID, userID?, period, amount }], updatedUser } -> { saved }
// upserts per branch + salesman + month; an amount of 0 / null removes the target
export const saveSalesTargets = async (data) => {
  const response = await axios.post(`${R}/SaveBulk`, data);
  return response.data;
};

// { fromPeriod, toPeriod, overwrite, branchIDs?, updatedUser } -> { saved }
export const copySalesTargets = async (data) => {
  const response = await axios.post(`${R}/CopyPeriod`, data);
  return response.data;
};

// { guid, updatedUser }
export const deleteSalesTarget = async (data) => {
  const response = await axios.post(`${R}/Delete`, data);
  return response.data;
};
